/**************************************************
 * Nombre:       Dialogo_Cuenta_Documentos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../../Modulo_formularios/Hooks/useFormulario";
import logo from '../../../Recursos/logo_redondo.svg'
import {guardarDoc} from "../../../Servicios/BD/guardarDoc";
import {subirImagenHostingFile} from "../../../Servicios/AlmacenamientoHosting/subirImagenHostingFile";
import {Delete} from "@mui/icons-material";
import {borrarDoc} from "../../../Servicios/BD/borrarDoc";
import Formulario_Usuario from "../../Formularios/Formulario_Usuario";
import {getID} from "../../../Servicios/BD/useEscucharUsuarioToCorreo";
import {useCargador} from "../../../Modulo_Cargador/Hooks/useCargador";
import Formulario_Cuentas from "../../Formularios/Cuentas/Formulario_Cuentas";
import Formulario_Cuentas_Documentos from "../../Formularios/Cuentas/Formulario_Cuentas_Documentos";
import {subirPdfHostingFile} from "../../../Servicios/AlmacenamientoHosting/subirPdfHostingFile";

const Dialogo_Cuenta_Documentos = ({datos, cerrar, realizado}) => {
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})
    const {Avisos, Cargador, nuevoAviso, terminar, iniciarCarga} = useCargador({
        logoRedondo: logo,
        funcionUno: realizado,
        funcionDos: cerrar
    })


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()

        iniciarCarga('Subiendo Datos')

        let docs = entidad.documentos;
        let arr = []
        if (docs && docs.length > 0) {

            for (let doc of docs) {

                if (doc.tipo === 'Pdf'){
                    let resultado = await subirPdfHostingFile(doc.recurso)
                    arr.push({...doc, recurso: resultado.data})
                }else{
                    let resultado = await subirImagenHostingFile(doc.recurso)
                    arr.push({...doc, recurso: resultado.data})

                }
            }

        }


        entidad.documentos = arr



        let dox = await guardarDoc('cuentas', entidad)
        if (dox.res) {
            terminar({aviso: 'Datos subidos con exito'})
        } else {
            terminar({aviso: 'Algo sali mal, por favor intetalo nuevamente', variante: 'error'})
        }


    }


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Cuentas_Documentos props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Guardar Datos</Button>
            </Grid>




        </Grid>
    )

}
export default Dialogo_Cuenta_Documentos